import { render } from "./POSLayout.vue?vue&type=template&id=61f9a0ae&scoped=true"
import script from "./POSLayout.vue?vue&type=script&lang=js"
export * from "./POSLayout.vue?vue&type=script&lang=js"

import "./POSLayout.vue?vue&type=style&index=0&id=61f9a0ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f9a0ae"]])

export default __exports__